/* arissai-new-drop.js v29 — NEW DROP ribbon for SHOP ALL menu */
(function(){
  "use strict";
  var THRESHOLD_DAYS = 21;
  var BADGE_TEXT = "NEW";

  function isRecent(iso){
    if (!iso) return false;
    var ms = Date.now() - new Date(iso).getTime();
    return ms < THRESHOLD_DAYS * 24 * 60 * 60 * 1000;
  }

  function stampShopAllParent(){
    // Find the SHOP ALL <summary>
    var sums = document.querySelectorAll('header summary, header-menu summary, .header__menu summary');
    sums.forEach(function(s){
      if (s.dataset.arissaiBadged) return;
      var txt = (s.textContent||"").trim().toUpperCase();
      if (txt.indexOf("SHOP") === -1) return;
      var dot = document.createElement('span');
      dot.className = 'arissai-newdrop-dot';
      dot.setAttribute('aria-hidden','true');
      s.appendChild(dot);
      s.dataset.arissaiBadged = "1";
    });
  }

  function stampSubmenuItems(recentHandles){
    // Find every header submenu link and check its href against recentHandles
    var links = document.querySelectorAll('header a[href*="/collections/"], header-menu a[href*="/collections/"], .header__submenu a, .mega-menu a');
    links.forEach(function(a){
      if (a.dataset.arissaiBadged) return;
      var href = a.getAttribute('href') || '';
      var m = href.match(/\/collections\/([^\/\?#]+)/);
      if (!m) return;
      var handle = decodeURIComponent(m[1]).toLowerCase();
      if (!recentHandles.has(handle)) return;
      var pill = document.createElement('span');
      pill.className = 'arissai-newdrop-pill';
      pill.textContent = BADGE_TEXT;
      a.appendChild(pill);
      a.dataset.arissaiBadged = "1";
    });
  }

  function init(){
    stampShopAllParent();
    // Fetch latest products + their collection associations
    if (!window.fetch) return;
    fetch('/products.json?limit=20', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(data){
        var recentHandles = new Set();
        (data.products || []).forEach(function(p){
          if (!isRecent(p.created_at)) return;
          // We don't have collections in this JSON. Use product_type / tags as a hint.
          if (p.product_type) recentHandles.add(p.product_type.toLowerCase().replace(/\s+/g,'-'));
          (p.tags || '').split(',').map(function(t){return t.trim().toLowerCase();}).forEach(function(t){
            if (t) recentHandles.add(t.replace(/\s+/g,'-'));
          });
        });
        // Always include "all" as a recent destination
        recentHandles.add('all');
        stampSubmenuItems(recentHandles);
      })
      .catch(function(){});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      if ('requestIdleCallback' in window) requestIdleCallback(init, { timeout: 600 });
      else setTimeout(init, 100);
    });
  } else {
    if ('requestIdleCallback' in window) requestIdleCallback(init, { timeout: 600 });
    else setTimeout(init, 100);
  }
})();
